export class QuotaExceededError extends Error {
  message = 'Quota exceeded';
}
